var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vbt-badge',{attrs:{"color":_vm.color,"small":""}},[_vm._v(" "+_vm._s(_vm.period)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }